import React from 'react'

const Facts = () => {
  return (
    <div class="container-xxl py-5">
    <div class="container py-5">
        <div class="row g-5  d-flex justify-content-center align-items-center">
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <h6 class="text-secondary text-uppercase mb-3">Some Facts</h6>
                <h1 class="mb-5">Your Trusted Partner for Industrial Tools & Solutions</h1>
<p class="mb-5">R.S. Industrial Solutions is a one-stop destination for premium industrial tools and consumables. Established in 2021, we specialize in providing high-quality Lubrication Equipment, Pneumatic Tools, Hydraulic Equipment, Hand Tools, Cutting Tools, Power Tools, Abrasives, PPEs, Lifting Equipment, and complete Automobile Workshop solutions.</p>
<p class="mb-5">With a dedicated team of industry professionals, engineers, and technical designers, we ensure that every product meets international quality standards. Our commitment to excellence, timely deliveries, and customer satisfaction has helped us build a strong reputation in the industry.</p>
                <div class="d-flex align-items-center">
                    <i class="fa fa-headphones fa-2x flex-shrink-0 bg-primary p-3 text-white"></i>
                    <div class="ps-4">
                        <h6>Call for any query!</h6>
                        <h3 class="text-primary m-0">+91-8368771407</h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="row g-4 align-items-center">
                    <div class="col-sm-6">
                        <div class="bg-primary p-4 mb-4 wow fadeIn" data-wow-delay="0.3s">
                            <i class="fa fa-users fa-2x text-white mb-3"></i>
                            <h2 class="text-white mb-2" data-toggle="counter-up">1400</h2>
                            <p class="text-white mb-0">Happy Clients</p>
                        </div>
                        <div class="bg-secondary p-4 wow fadeIn" data-wow-delay="0.5s">
                            <i class="fa fa-ship fa-2x text-white mb-3"></i>
                            <h2 class="text-white mb-2" data-toggle="counter-up">2000</h2>
                            <p class="text-white mb-0">Complete Shipments</p>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="bg-success p-4 wow fadeIn" data-wow-delay="0.7s">
                            <i class="fa fa-star fa-2x text-white mb-3"></i>
                            <h2 class="text-white mb-2" data-toggle="counter-up">1500</h2>
                            <p class="text-white mb-0">Customer Reviews</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default Facts